export default "__VITE_ASSET__BSvm7$hA__"